<template>
	<TemplateBase
		:is-sales="isSales"
		class="bg-gray-50"
	>
		<div
			class="bg-gradient-to-r from-purple-700 to-purple-900 w-full flex flex-col justify-end items-center pt-32 mb-32"
		>
			<div
				class="container flex flex-col items-center gap-16 max-w-screen-md -mb-16"
			>
				<LazyAtomBreadcrumbs
					v-if="breadcrumbs"
					:breadcrumbs="breadcrumbs"
					class="text-functional-size-sm"
				/>
				<AtomCard
					class="flex flex-col gap-8 text-center py-16 px-16 w-full"
				>
					<AtomTitle
						tag="h1"
						size="3xl"
					>
						{{ title }}
					</AtomTitle>
					<p class="text-paragraph-size-lg mb-8">
						{{ description }}
					</p>
					<div class="flex justify-center">
						<AtomButton
							:variant="ButtonVariant.Green"
							size="xl"
							:text="buttonText"
							icon-left="fa-calendar-days"
							@click="openAppointmentDialog"
						/>
					</div>
				</AtomCard>
			</div>
		</div>
		<div>
			<slot />
		</div>
	</TemplateBase>
</template>

<script lang="ts" setup>
import { ButtonVariant } from '#base/core/enums/ButtonVariantEnum';
import type { BreadcrumbsType } from '#base/core/types/BreadcrumbsType';

defineProps<{
	breadcrumbs?: BreadcrumbsType;
	isSales?: boolean;
	title: string;
	description: string;
	buttonText: string;
}>();

const {
	openAppointmentDialog,
} = useDialogs();
</script>
